import { PropsWithChildren } from 'react';

import './ImageSection.scss';

type Props = {
  comingSoon: boolean;
  imageUrl: string;
};

export const ImageSection = ({ comingSoon, imageUrl, children }: PropsWithChildren<Props>) => {
  return (
    <div
      className='module-image'
      style={{
        backgroundImage: comingSoon
          ? `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${imageUrl})`
          : `url(${imageUrl})`,
      }}
    >
      <div className='module-tag'>{children}</div>
    </div>
  );
};
